import { InjectionToken } from '@angular/core';

import { ISportEvent } from '@frontend/oxygen/shared-utils';
import { Observable } from 'rxjs';

import { ISportServiceConfig } from '../../core/models/sport-service-config.model';
import { IInitialSportConfig } from '../../core/services/sport/config/initial-sport-config.model';

export interface IRacingServiceInterface {
    setConfig(config: IInitialSportConfig): this;
    config: ISportServiceConfig;
    getSport(): this;
    isSpecialsAvailable(url: string, isCheckSpecial?: boolean): Observable<boolean>;
    groupByFlagCodesAndClassesTypeNames(eventsArray: any, countryFlags?: string[]): any;
    getNextRacesData(filterAccess: any, nextRacesModule: any, isAllEnabled: boolean): any;
    isRacingSpecials(racecardFirstItem: ISportEvent): any;
    // Add other shared methods/properties if needed
}

export const HORSE_RACING_SERVICE = new InjectionToken<IRacingServiceInterface>('HorseracingService');
export const GREYHOUND_SERVICE = new InjectionToken<IRacingServiceInterface>('GreyhoundService');
